import { ReactNode } from 'react';
import { css, cx } from '@linaria/atomic';
import { breakpoints } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';

type Props = {
  children: ReactNode;
  onClick?: () => void;
  className?: string;
};

const headerStyle = css`
  align-items: center;
  border-bottom: 1px solid ${theme.colors.neutral20};
  display: flex;
  padding: ${theme.spacing(3, 3, 2, 3)};
  justify-content: space-between;
  @media screen and (max-width: ${breakpoints.small.min}px) {
    h1 {
      font-size: ${theme.fontSize(24)};
    }
  }
`;

export const ContentPanelHeaderBar = ({ children, onClick, className, ...rest }: Props) => {
  return (
    <header onClick={onClick} className={cx(headerStyle, className)} {...rest}>
      {children}
    </header>
  );
};
